module.exports = __webpack_public_path__ + "r-4.png?01125ac2d70eac81e38446c0cccd02f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-4.png
// module id = 63
// module chunks = 0